import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const getBikeModels = async (params) => {
    const modelId = params?._id;

    if (modelId) {
        try {
            const res = await leadsServiceApi({
                method: 'get',
                url: `${PURCHASING_API.BIKE_MODELS}/${modelId}`,
            });

            return {
                result: true,
                options: [res.data],
            };
        } catch (e) {
            return {
                msg: e.message,
                error: e,
            };
        }
    }

    const searchText = params?.searchText || '';
    const brandId = params?.brandId || '';

    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_MODELS}?filterByName=${searchText}&filterByAlternativeName=${searchText}&brandId=${brandId}&limit=25`,
        });
        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/get_bike_models_request.js